<template>
  <el-descriptions
    id="infoDesc"
    size="medium"
    border
    :labelStyle="{ 'min-width': '100px' }"
  >
    <div slot="title">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
      <el-tag
        class="fm-margin-left-10"
        :type="$jsTool.getOrderApprovalStatusType(head.orderApprovalStatusEnum)"
        >{{ head.orderApprovalStatusEnum.Desc }}</el-tag
      >
    </div>
    <el-descriptions-item label="单号" span="2">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
    </el-descriptions-item>
    <el-descriptions-item label="单据日期" span="1">
      {{ head.orderDate }}
    </el-descriptions-item>
    <el-descriptions-item label="供应商" span="2">
      {{ head.supplier.name }}
    </el-descriptions-item>
    <el-descriptions-item label="" span="1">
      <el-tooltip
        slot="label"
        content="使用供应商余额将直接扣减或增加供应商余额，无需选择付款的资金账户"
        placement="top"
      >
        <span>
          <i class="el-icon-question"></i>
          使用供应商余额
        </span>
      </el-tooltip>
      <span v-fmtype="head.useBalance ? 'success' : 'error'">{{
        head.useBalance ? "使用" : "不使用"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="所选单据" span="3">
      <el-table
        :data="itemList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="300px"
        style="max-width: 750px"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="50"
          align="center"
          header-align="center"
          fixed="left"
          sortable
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="orderNo"
          label="关联单号"
          width="150"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.relatedCustomizePurchaseOrderHead.orderNo }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orderNo"
          label="单据金额"
          width="150"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <FmAmount
              :amount="scope.row.relatedCustomizePurchaseOrderHead.orderAmount"
            ></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="payAmount"
          label="付款金额"
          width="150"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.payAmount"></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="disCountAmount"
          label="优惠金额"
          width="150"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.disCountAmount"></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="实付金额"
          width="150"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.itemAmount"></FmAmount>
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item label="资金账户" span="3" v-if="!head.useBalance">
      <div class="fm-flex">
        <el-image
          style="width: 18px; height: 18px"
          fit="cover"
          class="fm-margin-right-5"
          :src="
            $jsTool.getFundAccountImageSrc(head.fundAccount.fundAccountTypeEnum)
          "
        ></el-image>
        {{ head.fundAccount.name }}
      </div>
    </el-descriptions-item>
    <el-descriptions-item label="单据金额" span="3">
      <div class="fm-flex">
        <FmAmount :amount="head.orderAmount"></FmAmount>
        （付款总额：<FmAmount :amount="head.payTotalAmount"></FmAmount
        >，付款优惠：<FmAmount :amount="head.disCountAmount"></FmAmount>）
      </div>
    </el-descriptions-item>
    <el-descriptions-item label="纸质单据" span="3">
      <OrderImageList
        :list="head.paperOrderImageList"
        name="纸质单据图片"
      ></OrderImageList>
    </el-descriptions-item>
    <el-descriptions-item label="付款凭证" span="3">
      <OrderImageList
        :list="head.payVoucherImageList"
        name="付款凭证图片"
      ></OrderImageList>
    </el-descriptions-item>
    <el-descriptions-item label="备注" span="3">
      <span v-fmtype="head.remark ? '' : 'warning'">{{
        head.remark || "——"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="业务员" span="1">
      {{ head.saleUserList.map((d) => d.user.name).join("、") }}
    </el-descriptions-item>
    <el-descriptions-item label="流程信息" span="3">
      <OrderStep :orderInfo="head" :displayTime="displayTime"></OrderStep>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  name: "Fmerpv2WebCustomizePayOrderInfo",
  props: {
    orderInfo: {
      type: [Object],
      default: null,
    },
  },
  watch: {
    orderInfo: {
      handler(newVal, val) {
        if (newVal) {
          this.showOrderInfo = newVal;
          setTimeout(() => {
            this.getOrderConfig();
            this.getOrderInfo();
          }, 10);
        }
      },
      immediate: true,
    },
  },

  computed: {
    head() {
      return this.showOrderInfo && this.showOrderInfo.head
        ? this.showOrderInfo.head
        : {};
    },
    itemList() {
      return this.showOrderInfo && this.showOrderInfo.itemList
        ? this.showOrderInfo.itemList
        : [];
    },
  },
  data() {
    return {
      showOrderInfo: null,
      needApproval: true,
      displayTime: true,
    };
  },

  mounted() {},

  methods: {
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:CustomizePayOrder:NeedApproval",
        "Order:CustomizePayOrder:DisplayCreateTime",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizePayOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.needApproval = false;
        }
        let displayTimeIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizePayOrder:DisplayCreateTime"
        );
        if (
          displayTimeIndex > -1 &&
          res.data[displayTimeIndex].value == "false"
        ) {
          this.displayTime = false;
        }
      }
    },
    async getOrderInfo() {
      let requestRes = await this.$api.customizePayOrder_findVoById(
        this.orderInfo.head.id,
        {
          showLoading: true,
          loadingParam: {
            target: "#infoDesc",
            lock: true,
          },
        }
      );
      if (requestRes && requestRes.success) {
        this.showOrderInfo = requestRes.data;
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/CustomizePayOrderInfo.vue